// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDUCKjr41ykQhLbMwlJHbOK_SijhOZzFLU",
  authDomain: "shesh-26dda.firebaseapp.com",
  projectId: "shesh-26dda",
  storageBucket: "shesh-26dda.appspot.com",
  messagingSenderId: "751699586793",
  appId: "1:751699586793:web:ba7f0579d52f17a4780a78"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;